<template>
  <v-container class="pa-0 mx-auto home">
    <v-row no-gutters>
      <v-col cols="12" sm="6" class="text-center">
        <img
          :src="images.jaceyUwill"
          style="margin-top:44px;"
          alt="Uwill"
          :style="
            $vuetify.display.smAndUp ? 'max-width:560px;' : 'max-width:300px;'
          "
        />
      </v-col>
      <v-col
        cols="10"
        offset="1"
        sm="5"
        offset-sm="0"
        class="text-center"
        :style="
          $vuetify.display.smAndUp ? 'margin-top:44px;' : 'margin-top:40px;'
        "
        order="first"
        order-sm="last"
      >
        <div class="d-none d-md-block">
          <a href="https://uwill.com">
            <img
              :src="images.uwill"
              style="max-width:250px;"
              alt="Uwill Student Mental Health & Wellness"
            />
          </a>
        </div>
        <div class="subtitle-text">
          Join us today and take the first step toward real solutions. Whether
          you're facing stress, change, or uncertainty, we'll help you access
          the right support and tools to overcome challenges and move forward
          with confidence.
        </div>
        <div
          class="buttons"
          :style="
            $vuetify.display.smAndUp ? 'margin-top:36px;' : 'margin-top:30px;'
          "
        >
          <v-btn
            size="x-large"
            elevation="0"
            class="btn uwill-primary-button shadowed"
            href="/register"
          >
            Get Started
          </v-btn>
          <div style="margin-top:24px;">
            <v-btn
              size="x-large"
              elevation="0"
              class="btn inverse"
              href="/register?has_code=true"
            >
              I have an invitation code
            </v-btn>
            <p style="margin-top:36px;">
              <a href="/login">Log in to my account</a>
            </p>
          </div>
        </div>
        <div style="margin-top:80px;" class="provider-registration">
          If you're interested in providing services through Uwill, please
          <a href="/register?classification=provider">click here to register</a>.
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Home",

  data: () => ({
    images: {
      jaceyUwill: require("@/assets/images/jacey_uwill.png"),
      uwill: require("@/assets/images/uwill_with_slogan.jpeg")
    }
  }),
  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn;
    }
  },
  beforeCreate() {
    this.$store.commit("DASHBOARD_FALSE");
  },
  mounted: function() {}
};
</script>
